<template>
  <div class="memberList">
    <div class="tabs">
      <div
        class="item"
        :class="data.tabsClassFlag('levelOne')"
        @click="data.tabClick('levelOne')"
      >
        <span>一级团员({{ inviteStore.teamInfo.one_sum }})</span>
      </div>
      <div
        class="item"
        :class="data.tabsClassFlag('levelTwo')"
        @click="data.tabClick('levelTwo')"
      >
        <span>二级团员({{ inviteStore.teamInfo.two_sum }})</span>
      </div>
    </div>
    <van-list
      v-model:loading="data.loading"
      :finished="data.finished"
      finished-text="没有更多了"
      @load="data.onLoad"
    >
      <div class="cardList">
        <div v-for="item in inviteStore.memberList" :key="item.user_id">
          <div class="card">
            <div class="header">
              <div class="iphone">{{ item.phone }}</div>
              <div class="spread" v-if="inviteStore.quitMemberItem === 'levelOne'">
                推广<span>{{ item.subordinates_count }}</span
                >人
              </div>
            </div>
            <div class="order">
              <div class="orderNum">{{ item.count_order }}个订单</div>
              <div class="prcieNum">{{ item.sum_commission }}元</div>
            </div>
            <div class="bindingTime">绑定时间:{{ item.ctime }}</div>
          </div>
        </div>
      </div>
    </van-list>
  </div>
</template>

<script setup>
import {
  ref,
  reactive,
  toRefs,
  onBeforeMount,
  onMounted,
  watchEffect,
  computed,
  defineComponent,
  defineExpose,
} from "vue";
import { useRoute, useRouter } from "vue-router";
import { useInviteStore } from "@/store/invite";
import { teamUser } from "@/api/invite";
defineComponent({
  name: "",
});
const inviteStore = useInviteStore();
/**
 * 路由对象
 */
const route = useRoute();
/**
 * 路由实例
 */
const router = useRouter();
//console.log('1-开始创建组件-setup')
/**
 * 数据部分
 */
const data = reactive({});

data.tabsClassFlag = (e) => {
  if (inviteStore.quitMemberItem === e) {
    return "quitItem";
  }
};

inviteStore.getTeamInfo();
inviteStore.clearMemberList();

// -----
data.loading = false;
data.finished = false;
data.teamUserParmas = {
  level: inviteStore.quitMemberItem === "levelOne" ? "1" : "2",
  page: 1,
  limit: 10,
};
// ----

data.getTeamUserList = () => {
  data.loading = true;
  teamUser(data.teamUserParmas).then((res) => {
    inviteStore.addMemberList(res.data.data);
    console.log(res.data.total, inviteStore.memberList.length);
    if (res.data.total === inviteStore.memberList.length) {
      data.finished = true;
      data.loading = false;
    } else {
      data.teamUserParmas.page++;
      data.loading = false;
    }
  });
};

data.tabClick = (e) => {
  data.teamUserParmas.level = e === "levelOne" ? "1" : "2";
  inviteStore.setQuitMemberItem(e);
  inviteStore.clearMemberList();
  data.finished = false;
  data.getTeamUserList();
};

data.onLoad = () => {
  console.log(1);
  data.getTeamUserList();
};

onBeforeMount(() => {
  //console.log('2.组件挂载页面之前执行----onBeforeMount')
});
onMounted(() => {
  //console.log('3.-组件挂载到页面之后执行-------onMounted')
});
watchEffect(() => {});
// 使用toRefs解构
// let { } = { ...toRefs(data) }
defineExpose({
  ...toRefs(data),
});
</script>
<style lang="scss" scoped>
.tabs {
  display: flex;
  border-bottom: 1px solid #ffffff20;
  .item {
    text-align: center;
    flex: 1;
    font-weight: 400;
    color: #f7f5ff80;
    font-size: 28px;
    padding: 19px 0;
  }
  .quitItem {
    color: #ffffff;
    font-size: 30px;
    font-weight: 500;
    span {
      position: relative;
    }
  }
  .quitItem {
    span::after {
      content: "";
      position: absolute;
      bottom: -24px;
      left: 0;
      height: 4px;
      background: #8368fc;
      border-radius: 3px;
      width: 48px;
      margin: 0 61px;
    }
  }
}
.van-list {
  height: calc(100vh - 210px);
  overflow: hidden;
  overflow-y: auto;
}

.van-list::-webkit-scrollbar {
  width: 0 !important;
}
.cardList {
  margin-top: 28px;
  .card {
    background: #323647;
    border-radius: 16px;
    margin: 0 24px;
    margin-top: 20px;
    padding-top: 24px;
    .header {
      padding: 0 24px;
      font-weight: 500;
      color: #ffffff;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .iphone {
        font-size: 30px;
      }
      .spread {
        font-size: 28px;
        span {
          color: #8368fcff;
        }
      }
    }
    .order {
      margin-top: 8px;
      padding: 0 24px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-bottom: 20px;
      border-bottom: 1px solid #f7f5ff30;
      .orderNum {
        color: #f7f5ff80;
      }
      .prcieNum {
        color: #ffffff;
      }
    }
    .bindingTime {
      padding: 16px 24px;
      color: #f7f5ff60;
      font-weight: 300;
      font-size: 24px;
    }
  }
  .search {
    display: flex;
    justify-content: center;
    align-items: center;
    color: #ffffff;
    font-size: 28px;
    margin-top: 26px;
    margin-bottom: 34px;
    img {
      width: 44px;
      height: 44px;
    }
  }
}
</style>
